/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Vb365Server { 
    /**
     * UID assigned to a Veeam Backup for Microsoft 365 server.
     */
    readonly instanceUid?: string | null;
    /**
     * UID assigned to a Veeam Backup for Microsoft 365 server location.
     */
    readonly locationUid?: string;
    /**
     * UID assigned to an organization.
     */
    readonly organizationUid?: string;
    /**
     * UID assigned to a management agent installed on a Veeam Backup for Microsoft 365 Server.
     */
    readonly managementAgentUid?: string;
    /**
     * UID assigned to a Veeam Backup for Microsoft 365 server installation.
     */
    readonly installationUid?: string | null;
    /**
     * Host name of a Veeam Backup for Microsoft 365 server.
     */
    readonly name?: string;
    /**
     * Version of Veeam Backup for Microsoft 365 installed on a server.
     */
    readonly version?: string;
    /**
     * Major version of Veeam Backup for Microsoft 365 installed on a server.
     */
    readonly majorVersion?: number;
    /**
     * Veeam Backup for Microsoft 365 server status.
     */
    readonly status?: Vb365ServerStatus;
    /**
     * Status of a management agent.
     */
    readonly managementAgentStatus?: Vb365ServerManagementAgentStatus;
    /**
     * Type of Veeam Backup for Microsoft 365 server ownership.
     */
    readonly ownership?: Vb365ServerOwnership;
}
export enum Vb365ServerStatus {
    Unknown = 'Unknown',
    Healthy = 'Healthy',
    Warning = 'Warning',
    Inaccessible = 'Inaccessible'
};
export enum Vb365ServerManagementAgentStatus {
    Unknown = 'Unknown',
    Healthy = 'Healthy',
    Inaccessible = 'Inaccessible',
    Warning = 'Warning',
    Updating = 'Updating',
    Error = 'Error',
    Restarting = 'Restarting',
    Installation = 'Installation',
    FailedToUpdate = 'FailedToUpdate'
};
export enum Vb365ServerOwnership {
    Unknown = 'Unknown',
    Client = 'Client',
    Hosted = 'Hosted'
};



